import { MSDropdown } from '../../common/dropdown/index.js';
import { makeid } from '../../common/utils/idgen.js';
import i18next from "i18next";
import styles from './menu.css'

const eyeIcon = `
    <svg width="19" height="13" viewBox="0 0 19 13" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.5 9.48336C10.522 9.48336 11.3892 9.15168 12.1017 8.48833C12.8142 7.82498 13.1705 7.01757 13.1705 6.0661C13.1705 5.11463 12.8142 4.30722 12.1017 3.64387C11.3892 2.98052 10.522 2.64884 9.5 2.64884C8.47803 2.64884 7.6108 2.98052 6.8983 3.64387C6.1858 4.30722 5.82955 5.11463 5.82955 6.0661C5.82955 7.01757 6.1858 7.82498 6.8983 8.48833C7.6108 9.15168 8.47803 9.48336 9.5 9.48336ZM9.5 8.31747C8.82349 8.31747 8.25133 8.09971 7.78352 7.66417C7.31572 7.22864 7.08182 6.69595 7.08182 6.0661C7.08182 5.43625 7.31572 4.90356 7.78352 4.46803C8.25133 4.0325 8.82349 3.81473 9.5 3.81473C10.1765 3.81473 10.7487 4.0325 11.2165 4.46803C11.6843 4.90356 11.9182 5.43625 11.9182 6.0661C11.9182 6.69595 11.6843 7.22864 11.2165 7.66417C10.7487 8.09971 10.1765 8.31747 9.5 8.31747ZM9.5 12.0966C7.39848 12.0966 5.49849 11.5404 3.8 10.4281C2.10152 9.31585 0.834848 7.86184 0 6.0661C0.834848 4.27037 2.10152 2.81635 3.8 1.70407C5.49849 0.591787 7.39848 0.0356445 9.5 0.0356445C11.6015 0.0356445 13.5015 0.591787 15.2 1.70407C16.8985 2.81635 18.1652 4.27037 19 6.0661C18.1652 7.86184 16.8985 9.31585 15.2 10.4281C13.5015 11.5404 11.6015 12.0966 9.5 12.0966ZM9.5 10.8905C11.2417 10.8905 12.843 10.4516 14.304 9.57382C15.765 8.69605 16.8769 7.52681 17.6398 6.0661C16.8769 4.60539 15.765 3.43615 14.304 2.55839C12.843 1.68062 11.2417 1.24174 9.5 1.24174C7.75833 1.24174 6.15701 1.68062 4.69602 2.55839C3.23504 3.43615 2.11591 4.60539 1.33864 6.0661C2.11591 7.52681 3.23504 8.69605 4.69602 9.57382C6.15701 10.4516 7.75833 10.8905 9.5 10.8905Z"/>
    </svg>
`

const valuesArray = () => [
    { label: i18next.t('legend_title_pen'), value: "pen", field: "showpen" },
    { label: i18next.t('legend_title_name'), value: "name", field: "showname" },
    { label: i18next.t('legend_title_source'), value: "source", field: "showsource" },
    { label: i18next.t('legend_title_group'), value: "group", field: "showgroup" },
    { label: i18next.t('legend_title_units'), value: "unit", field: "showunit" },
    { label: i18next.t('legend_title_value'), value: "value", field: "showvalue" },
    { label: i18next.t('legend_title_avarage'), value: "avarage", field: "showavarage" },
    { label: i18next.t('legend_title_comment'), value: "comment", field: "showcomment" },
    { label: i18next.t('legend_title_lasttime'), value: "timeAfter", field: "showlastvaluetime" },
    { label: i18next.t('legend_title_isbad'), value: "quality", field: "showquality" },
    { label: i18next.t('legend_title_scalemin'), value: "min", field: "showmin" },
    { label: i18next.t('legend_title_scalemax'), value: "max", field: "showmax" },
    { label: i18next.t('legend_title_lolo'), value: "nay", field: "shownau" },
    { label: i18next.t('legend_title_lo'), value: "npy", field: "shownpu" },
    { label: i18next.t('legend_title_hi'), value: "vpy", field: "showvpu" },
    { label: i18next.t('legend_title_hihi'), value: "vay", field: "showvau" },
    { label: i18next.t('legend_title_start'), value: "startValue", field: "showstartvalue" },
    { label: i18next.t('legend_title_min'), value: "minValue", field: "showminvalue" },
    { label: i18next.t('legend_title_max'), value: "maxValue", field: "showmaxvalue" },
    { label: i18next.t('legend_title_end'), value: "endValue", field: "showlastvalue" },
];

const generateMenuRow = (el, visible = true) => {
    return `
        <div class="menu-el-wrap">
            <div class="menu-checkbox ${visible ? "visible" : ""}">${eyeIcon}</div>
            <div class="menu-list-text">${el}</div>
        </div>
    `
}

const template = () => `
    <style>
        ${styles}
    </style>
    <div id="menu-legend-root">
        <ui-dropdown drop-position="bottom" value="" id="legend-dropdown">
            <div slot="label" id="group-dropdown-label" class="group-dropdown-label">
                <div class="legend-menu"><div class="icon-menu"></div></div>
            </div>
        </ui-dropdown>
    </div>
`;

/**
 * @class ChartGroups
 * @classdesc Группы столбчатой диаграммы
 * */
export class LegendMenu {
    constructor(container, root) {
        this.container = container
        this.root = root
        this.values = []
        this.container.innerHTML = template()
        this.root.checkComponent('ui-dropdown', MSDropdown)
        this.initDropdown()
    }

    genValues() {
        this._values.length = 0
        const values = valuesArray()
        for (let i = 0; i < values.length; i++) {
            const elem = this.genRow(values[i])
            this._values.push(elem)
        }
    }

    genRow(el) {
        const elem = {
            id: makeid(10),
            component: generateMenuRow(el.label, this.root[el.field]),
            value: el.value,
            active: true,
            field: el.field
        }
        return elem
    }

    initDropdown() {
        this.dropdown = this.root.shadowRoot.querySelector('#legend-dropdown')
        this.dropdown.cssElem.innerHTML += styles
        this.dropdown.onClick = this.onToggle.bind(this)
        this.dropdown.values = this.values
        this.dropdown.createList()
        this.initAutoClose()
    }

    clickHandler = (e) => {
        e.stopPropagation();
        if (!this.dropdown?.active) return;
        const target = e.target;
        if (!target.shadowRoot && !this.dropdown.contains(target)) this.dropdown.active = false;
    };

    initAutoClose() {
        this.root.shadowRoot.addEventListener('click', this.clickHandler)
        window.addEventListener('click', (e) => {
            if (this.dropdown?.active) this.dropdown.active = false
        })
    }

    render() {
        this.dropdown.createList()
    }

    update() {
        this.genValues()
        this.render()
    }

    onToggle(e) {
        e.stopPropagation()
        const li = e.target.closest('li')
        const Value = li?.getAttribute('Value')
        if (!li || !Value) return
        const elem = this.values.find((elem) => elem.value === Value)
        if (!elem) return
        this.root[elem.field] = !this.root[elem.field]
        this.update()
        this.root.table.redraw()
    }

    destroy() {
        this.root.shadowRoot.removeEventListener('click', this.clickHandler);
        window.removeEventListener('click', this.clickHandler);

        this.dropdown = null;
        this._values = null
        this.root = null
        this.container.innerHTML = '';
        this.container = null
    }

    get values() {
        return this._values
    }

    set values(v) {
        this._values = v
        this.genValues()
    }
}